import React from "react";

export default function NoteModalCloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M13.1875 25.375C19.9185 25.375 25.375 19.9185 25.375 13.1875C25.375 6.45653 19.9185 1 13.1875 1C6.45653 1 1 6.45653 1 13.1875C1 19.9185 6.45653 25.375 13.1875 25.375Z"
        stroke="white"
        strokeWidth="2"
      />
      <path d="M9.65137 9.45166L17.2041 17.0044L9.65137 9.45166Z" fill="white" />
      <path
        d="M9.65137 9.45166L17.2041 17.0044"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M17.0049 9.45166L9.45219 17.0044L17.0049 9.45166Z" fill="white" />
      <path
        d="M17.0049 9.45166L9.45219 17.0044"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
